import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';

import { T } from '@flipster/i18n';
import { Explain } from '@flipster/react/design-utils/explain';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

// ROLLBACK(last-price): trigger price type 셀렉터 재활성화 시 복원 (useAtom import 포함).
// import { useAtom } from 'jotai';
// import { TriggerPriceTypeSelect } from '../../../../shared/trigger-price-type-select';
import { tpslModalInputBunja } from '../../state';
import { tpslModalValidationBunja } from '../../validation';
import { PriceRateButtons } from './price-rate-buttons';
import { TriggerPriceInput } from './trigger-condition-input';

export interface SetTriggerConditionSectionProps {
  title: ReactNode;
}
export const SetTriggerConditionSection = ({ title }: SetTriggerConditionSectionProps) => {
  const { triggerPriceStatusAtom } = useBunja(tpslModalValidationBunja);
  // ROLLBACK(last-price): 셀렉터 재활성화 시 triggerPriceTypeAtom 바인딩 복원.
  // const { isLimitTpslOrderAtom, triggerPriceTypeAtom } = useBunja(tpslModalInputBunja);
  // const [triggerPriceType, setTriggerPriceType] = useAtom(triggerPriceTypeAtom);
  const { isLimitTpslOrderAtom } = useBunja(tpslModalInputBunja);
  const triggerPriceStatus = useAtomValue(triggerPriceStatusAtom);
  const isLimitTpslOrder = useAtomValue(isLimitTpslOrderAtom);

  const isMarket = !isLimitTpslOrder;
  const showMarketDisclaimer = isMarket && triggerPriceStatus.status === 'valid';

  return (
    <section
      className={stack({
        px: 16,
        py: 12,
        gap: 12,
        rounded: 8,
        bg: 'background.default.level-1',
      })}
    >
      <div className={stack({ gap: 4 })}>
        <div className={hstack({ justifyContent: 'space-between', alignItems: 'center' })}>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}>{title}</p>
          {/* ROLLBACK(last-price): Last/Mark 셀렉터 — MM 준비 완료 시 재활성화.
          <TriggerPriceTypeSelect value={triggerPriceType} onChange={setTriggerPriceType} placement='label-suffix' /> */}
        </div>
        <TriggerPriceInput />
      </div>
      <PriceRateButtons />
      {triggerPriceStatus.status === 'error' ? (
        <Explain.Error>{triggerPriceStatus.message}</Explain.Error>
      ) : triggerPriceStatus.status === 'warning' ? (
        <Explain.Warning>{triggerPriceStatus.message}</Explain.Warning>
      ) : showMarketDisclaimer ? (
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
          <T id='Trade.r260420.Market_tp_sl_desc' />
        </p>
      ) : null}
    </section>
  );
};
